var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MarkerMap',{attrs:{"geometries":_vm.geometries}})
}
var staticRenderFns = []

export { render, staticRenderFns }